import api from './api';
import type {
  MovimientoCreateRequest,
  MovimientoDto,
  TipoMovimiento,
} from '@/types/inventario';

export interface MovimientoFilters {
  tipo?: TipoMovimiento | null;
  almacenId?: number | null;
  itemId?: number | null;
  desde?: string | null;
  hasta?: string | null;
  page?: number;
  size?: number;
}

/** Spring Page<T> shape — versión mínima usada en el frontend. */
export interface SpringPage<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export const movimientosApi = {
  registrar: (data: MovimientoCreateRequest) =>
    api.post<MovimientoDto>('/movimientos', data).then((r) => r.data),

  list: (filters: MovimientoFilters = {}) => {
    const params: Record<string, string | number> = {
      page: filters.page ?? 0,
      size: filters.size ?? 20,
    };
    if (filters.tipo) params.tipo = filters.tipo;
    if (filters.almacenId != null) params.almacenId = filters.almacenId;
    if (filters.itemId != null) params.itemId = filters.itemId;
    if (filters.desde) params.desde = filters.desde;
    if (filters.hasta) params.hasta = filters.hasta;
    return api
      .get<SpringPage<MovimientoDto>>('/movimientos', { params })
      .then((r) => r.data);
  },
};
